import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const stepRequirements = {
  recherche: [
    ['gender', '/rencontre/genre']
  ],
  relation: [
    ['gender', '/rencontre/genre'],
    ['genderSearch', '/rencontre/recherche']
  ],
  profil: [
    ['gender', '/rencontre/genre'],
    ['genderSearch', '/rencontre/recherche'],
    ['LookingFor', '/rencontre/relation']
  ],
  inscription: [
    ['gender', '/rencontre/genre'],
    ['genderSearch', '/rencontre/recherche'],
    ['LookingFor', '/rencontre/relation'],
    ['name', '/rencontre/profil'],
    ['doB', '/rencontre/profil']
  ],
  regles: [
    ['uid', '/rencontre/inscription']
  ],
  photos: [
    ['uid', '/rencontre/inscription'],
    ['acceptedPolicy', '/rencontre/regles']
  ],
  localisation: [
    ['uid', '/rencontre/inscription'],
    ['photos', '/rencontre/photos']
  ]
};

const EncounterRoute = ({ step, children }) => {
  const authState = useSelector(state => state.auth);
  const requirements = stepRequirements[step] || [];

  for (const [field, redirect] of requirements) {
    const value = authState[field];
    const complete = field === 'photos' ? value?.length >= 2 : !!value;
    if (!complete) return <Navigate to={redirect} replace />;
  }

  return children;
};

export default EncounterRoute;
